import Vue from 'vue'
import Router from 'vue-router'
import loginPage from '@/components/loginPage'
import searchPage from '@/components/searchPage'
import resultsPage from '@/components/resultsPage'
import registrationPage from '@/components/registrationPage'
import registrationPrintPage from '@/components/registrationPrintPage'
import userMaintenancePage from '@/components/userMaintenancePage'
import adminMaintenancePage from '@/components/adminMaintenancePage'
import companyManagementPage from '@/components/companyManagementPage'
import reportsPage from '@/components/reportsPage'
import reportsResults from '@/components/reportsResults'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'loginPage',
      component: loginPage
    },
    {
      path: '/search',
      name: 'searchPage',
      component: searchPage
    },
    {
      path: '/results',
      name: 'resultsPage',
      component: resultsPage
    },
    {
      path: '/registrationPrint',
      name: 'registrationPrintPage',
      component: registrationPrintPage
    },
    {
      path: '/registration',
      name: 'registrationPage',
      component: registrationPage
    },
    {
      path: '/userMaintenance',
      name: 'userMaintenancePage',
      component: userMaintenancePage
    },
    {
      path: '/adminMaintenance',
      name: 'adminMaintenancePage',
      component: adminMaintenancePage
    },
    {
      path: '/companyManagement',
      name: 'companyManagementPage',
      component: companyManagementPage
    },
    {
      path: '/reports',
      name: 'reportsPage',
      component: reportsPage
    },
    {
      path: '/reportsResults',
      name: 'reportsResultsPage',
      component: reportsResults
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js